import React from 'react';
import './styles/payout.css';

export default function StripePayout() {
  return <div />;
}
